module.exports = __webpack_public_path__ + "img/azxy10_bg.6f8ab051.png";